import moment from "moment/moment";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <>
      <footer id="footer" className="bg-footer-light">
        <div className="container">
          <footer className="d-flex flex-wrap justify-content-between align-items-center pt-2">
            <div className="col-md-6">
              <div className="bebas-neue-font text-default-color fw-bold fs-1 mb-0">
              <img src="..\Move-logo-BG-transparent.png"  height={30} />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center justify-content-end">
              <h6>copyright@{moment().format("YYYY")}</h6>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-dot"
                viewBox="0 0 16 16"
              >
                <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
              </svg>
              <h6>Move</h6>
            </div>
          </footer>
        </div>
      </footer>
    </>
  );
};

export default Footer;
